import { render, staticRenderFns } from "./PortalHome.vue?vue&type=template&id=2d1085f6&scoped=true&"
import script from "./PortalHome.vue?vue&type=script&lang=js&"
export * from "./PortalHome.vue?vue&type=script&lang=js&"
import style0 from "./PortalHome.vue?vue&type=style&index=0&id=2d1085f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1085f6",
  null
  
)

export default component.exports